export const PERMISSIONS = {
  FICHA_CREATE:       'ficha:create',
  FICHA_EDIT:         'ficha:edit',
  FICHA_VIEW:         'ficha:view',
  FICHA_DELETE:       'ficha:delete',
  PETITION_GENERATE:  'petition:generate',
  PETITION_REVIEW:    'petition:review',
  PETITION_APPROVE:   'petition:approve',
  KANBAN_VIEW:        'kanban:view',
  DASHBOARD_VIEW:     'dashboard:view',
  CONFIG_EDIT:        'config:edit',
  USERS_MANAGE:       'users:manage',
  SETTINGS_OFFICE:    'settings:office',
  SETTINGS_FIELDS:    'settings:fields',
  SETTINGS_TEMPLATES: 'settings:templates',
  SETTINGS_INTEGRATIONS: 'settings:integrations',
  SETTINGS_PARAMETROS: 'settings:parametros',
  JURIS_MANAGE:       'juris:manage',
  FICHA_COMPLETE_AFTER_APPROVAL: 'ficha:complete_after_approval',
  CASE_ARCHIVE:       'case:archive',
  FICHA_CONFERIR:     'ficha:conferir',
  PII_READ:           'pii:read',
};

export const ALL_PERMISSIONS = [
  { key: PERMISSIONS.FICHA_CREATE,       label: 'Criar ficha'          },
  { key: PERMISSIONS.FICHA_EDIT,         label: 'Editar ficha'         },
  { key: PERMISSIONS.FICHA_VIEW,         label: 'Ver fichas'           },
  { key: PERMISSIONS.FICHA_DELETE,       label: 'Excluir ficha'        },
  { key: PERMISSIONS.PETITION_GENERATE,  label: 'Gerar petição'        },
  { key: PERMISSIONS.PETITION_REVIEW,    label: 'Revisar petição'      },
  { key: PERMISSIONS.PETITION_APPROVE,   label: 'Aprovar petição'      },
  { key: PERMISSIONS.KANBAN_VIEW,        label: 'Ver Kanban'           },
  { key: PERMISSIONS.DASHBOARD_VIEW,     label: 'Ver Dashboard'        },
  { key: PERMISSIONS.CONFIG_EDIT,        label: 'Editar configurações' },
  { key: PERMISSIONS.USERS_MANAGE,       label: 'Gerenciar usuários'   },
  { key: PERMISSIONS.SETTINGS_OFFICE,    label: 'Configurar escritório' },
  { key: PERMISSIONS.SETTINGS_PARAMETROS, label: 'Editar parâmetros'    },
  { key: PERMISSIONS.SETTINGS_FIELDS,    label: 'Gerenciar campos'     },
  { key: PERMISSIONS.SETTINGS_TEMPLATES, label: 'Gerenciar templates'  },
  { key: PERMISSIONS.SETTINGS_INTEGRATIONS, label: 'Gerenciar integrações' },
  { key: PERMISSIONS.JURIS_MANAGE,       label: 'Gerenciar jurisprudências' },
  { key: PERMISSIONS.FICHA_COMPLETE_AFTER_APPROVAL, label: 'Completar ficha aprovada' },
  { key: PERMISSIONS.CASE_ARCHIVE,       label: 'Arquivar caso'        },
  { key: PERMISSIONS.FICHA_CONFERIR,     label: 'Conferir e aprovar ficha' },
  { key: PERMISSIONS.PII_READ,           label: 'Ver dados pessoais por API' },
];

export const ROLE_OPTIONS = [
  { value: 'admin',       label: 'Administrador' },
  { value: 'coordenacao', label: 'Coordenação'   },
  { value: 'advogado',    label: 'Advogado'      },
  { value: 'atendente',   label: 'Atendente'     },
  { value: 'estagiario',  label: 'Estagiário'    },
];

export const DEFAULT_ROLE_PERMISSIONS = {
  admin: ALL_PERMISSIONS.map(p => p.key),
  // Espelha ROLE_PERMISSIONS['coordenacao'] do backend (app/core/rbac.py); a paridade entre os
  // dois é travada por `test_frontend_permissions_parity`.
  coordenacao: [
    PERMISSIONS.FICHA_CREATE, PERMISSIONS.FICHA_EDIT, PERMISSIONS.FICHA_VIEW, PERMISSIONS.FICHA_DELETE,
    PERMISSIONS.PETITION_GENERATE, PERMISSIONS.PETITION_REVIEW, PERMISSIONS.PETITION_APPROVE,
    PERMISSIONS.KANBAN_VIEW, PERMISSIONS.DASHBOARD_VIEW, PERMISSIONS.CONFIG_EDIT, PERMISSIONS.USERS_MANAGE,
    PERMISSIONS.SETTINGS_OFFICE, PERMISSIONS.SETTINGS_FIELDS, PERMISSIONS.SETTINGS_TEMPLATES,
    PERMISSIONS.SETTINGS_INTEGRATIONS, PERMISSIONS.SETTINGS_PARAMETROS, PERMISSIONS.JURIS_MANAGE,
    PERMISSIONS.FICHA_COMPLETE_AFTER_APPROVAL, PERMISSIONS.CASE_ARCHIVE,
    PERMISSIONS.FICHA_CONFERIR, PERMISSIONS.PII_READ
  ],
  advogado: [
    PERMISSIONS.FICHA_CREATE, PERMISSIONS.FICHA_EDIT, PERMISSIONS.FICHA_VIEW,
    PERMISSIONS.PETITION_GENERATE, PERMISSIONS.PETITION_REVIEW, PERMISSIONS.PETITION_APPROVE,
    PERMISSIONS.KANBAN_VIEW, PERMISSIONS.DASHBOARD_VIEW, PERMISSIONS.CASE_ARCHIVE,
    PERMISSIONS.FICHA_CONFERIR, PERMISSIONS.PII_READ
  ],
  // Atendente e Estagiário revisam desde 15/09/2026 — ver ROLE_PERMISSIONS no backend.
  atendente: [
    PERMISSIONS.FICHA_CREATE, PERMISSIONS.FICHA_EDIT, PERMISSIONS.FICHA_VIEW,
    PERMISSIONS.PETITION_GENERATE, PERMISSIONS.PETITION_REVIEW,
    PERMISSIONS.KANBAN_VIEW, PERMISSIONS.DASHBOARD_VIEW
  ],
  estagiario: [
    PERMISSIONS.FICHA_CREATE, PERMISSIONS.FICHA_EDIT, PERMISSIONS.FICHA_VIEW,
    PERMISSIONS.PETITION_GENERATE, PERMISSIONS.PETITION_REVIEW,
    PERMISSIONS.KANBAN_VIEW, PERMISSIONS.DASHBOARD_VIEW
  ],
};
